import React from "react";
import { withRouter } from "react-router";
import { LuiMiniSpinner, LuiLoadingSpinner, LuiButton, LuiModal, LuiStaticMessage, LuiToastMessage } from "@linzjs/lui";
import { MultiCheckbox } from "./Forms";
import { Auth } from 'aws-amplify';

class Results extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      total: 0,
      detail: null,
      detailError: null,
      isDetailOpen: false,
      isDetailLoaded: false,
      noFilesError: false,
      session: null
    };

    this.handleChecked = this.handleChecked.bind(this);
    this.handleAllChecked = this.handleAllChecked.bind(this);
    this.showDetail = this.showDetail.bind(this);
  }
  
  handleErrors(response) {
    if (!response.ok) {
        return Promise.reject(response);
    }
    return response.json();
  }

  async componentDidMount() {
    const session = await Auth.currentSession();
    const headers = { "Authorization": "Bearer " + session.accessToken.jwtToken };
    const options = {
      method: "GET",
      headers: headers,
      mode: "cors",
      cache: "default"
    };
    const {offices, agencies, FileNumber, Title, partial} = this.props.location.state;
    const search = "?offices=" + offices.join(",") +
                 "&agencies=" + agencies.join(",") +
                 "&FileNumber=" + FileNumber +
                 "&Title=" + Title +
                 "&partial=" + partial;
    fetch("https://" + process.env.REACT_APP_API_URL + "/records" + search, options)
      .then(this.handleErrors)
      .then(results => {
          results.data.map(item => item["isChecked"] = false);
          this.setState({
            isLoaded: true,
            items: results.data,
            total: results.total
          });
        })
      .catch(error => {
        if (typeof error.json === "function") {
          error.json().then(jsonError => {
            this.setState({
              isLoaded: true,
              error: jsonError
            });
          }).catch(genericError => {
            this.setState({
              isLoaded: true,
              error: error.statusText
            });
          });
        } else {
          this.setState({
            isLoaded: true,
            error
          });
        }
      });
  }

  searchAgain() {
    this.props.history.push("/search");
  }

  requestFiles() {
    const files = this.state.items.filter(item => item.isChecked);
    if(files && files.length > 0) {
      this.props.history.push({
        pathname: "/request",
        state: {
          files: files
        }
      });
    } else {
      this.setState({noFilesError: true});
    }
  }

  async showDetail(uri) {
    this.setState({
      isDetailOpen: true,
      isDetailLoaded: false
    });
    const session = await Auth.currentSession();
    const headers = { "Authorization": "Bearer " + session.accessToken.jwtToken };
    const options = {
      method: "GET",
      headers: headers,
      mode: "cors",
      cache: "default"
    };
    fetch("https://" + process.env.REACT_APP_API_URL + "/records/" + uri, options)
      .then(this.handleErrors)
      .then(result => {
          this.setState({
            detail: result.data,
            isDetailLoaded: true
          });
        })
      .catch(error => {
        if (typeof error.json === "function") {
          error.json().then(jsonError => {
            this.setState({
              isDetailLoaded: true,
              detailError: jsonError
            });
          }).catch(genericError => {
            this.setState({
              isDetailLoaded: true,
              detailError: error.statusText
            });
          });
        } else {
          this.setState({
            isDetailLoaded: true,
            detailError: error
          });
        }
      });
  }

  handleAllChecked(event) {
    let items = this.state.items;
    items.forEach(item => item["isChecked"] = event.target.checked) 
    this.setState({items: items})
  }

  handleChecked(event) {
    const target = event.target;
    const items = this.state.items;
    const length = items.length;
    for (let i = 0; i < length; i++) {
      const item = items[i];
      if ("" + item.URI === target.value) {
        item["isChecked"] =  target.checked;
        break;
      }
    }
    this.setState({
      items: items,
      noFilesError: false
    });
  }

  render() {
    const { error, isLoaded, items, total, detail, detailError, isDetailOpen, isDetailLoaded, noFilesError } = this.state;
    const { offices, agencies, FileNumber, Title } = this.props.location.state;
    const resultsDescription = total > 200 ? " - only the first 200 are shown. Please refine your search" : "";
    return (
      <>
        {isDetailOpen && (
          <LuiModal
            lowContrast
            headingText="Details"
            shouldCloseOnOverlayClick
            onClose={() => {
              this.setState({isDetailOpen: false});
            }}
          >
          <div className="g-flex-col-sm-12">
            <div className="lui-text-content-area">
              <h2 className="demo-type">ELFI (Electronic LINZ File Index)</h2>
              {
                isDetailLoaded ? (
                  detailError ? (
                    <LuiStaticMessage level="error" closable={false}>
                      <p>{detailError.message}</p>
                    </LuiStaticMessage>) : (
                    <>
                      <table className="lui-base-table lui-table-zebra">
                        <tbody>
                          <tr>
                            <th>File Number</th>
                            <td>{detail.FileNumber.trim()}</td>
                          </tr>
                          <tr>
                            <th>Title</th>
                            <td>{detail.Title.trim()}</td>
                          </tr>
                          <tr>
                            <th>Owner</th>
                            <td>{detail.OwnerUnit.trim()}</td>
                          </tr>
                          <tr>
                            <th>Home Location</th>
                            <td>{detail.HomeLocationUnit.trim()}</td>
                          </tr>
                          <tr>
                            <th>Agency</th>
                            <td>{detail.Agency.trim()}</td>
                          </tr>
                          <tr>
                            <th>Land District</th>
                            <td>{detail.LandDistrict.trim()}</td>
                          </tr>
                          <tr>
                            <th>Date Created</th>
                            <td>{detail.DateCreated}</td>
                          </tr>
                          <tr>
                            <th>Date Closed</th>
                            <td>{detail.DateClosed}</td>
                          </tr>
                          <tr>
                            <th>LIPS number</th>
                            <td>{detail.LipsNumber.trim()}</td>
                          </tr>
                          <tr>
                            <th>Legal description/Notes</th>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                    </>
                  )
                ) : (
                  <div className="g-flex-container lui-margin-bottom-xxl">
                    <LuiMiniSpinner size={50} />
                  </div>
                )
              }
              </div>
            </div>
          </LuiModal>
        )}
        <div className="g-flex-col-sm-12">
          <div className="lui-text-content-area">
            <h1 className="demo-type">ELFI (Electronic LINZ File Index)</h1>
            {
              error ? (<>
                    <LuiStaticMessage level="error" closable={false}>
                      <p>Sorry - this request cannot be processed at the moment.</p>
                    </LuiStaticMessage>
                    <p>
                      <LuiButton onClick={() => this.searchAgain()}>Search Again</LuiButton>
                    </p>
                  </>
                ) : (<>
                    <p className="demo-type">
                      To request a file(s), tick the box next to the file name(s) then click the "Request Files" button at the bottom of the screen.
                    </p>
                    <h3>Your Search Criteria:</h3>
                    <div className="lui-divider">
                      <table className="lui-base-table lui-table-zebra">
                        <tbody>
                          <tr>
                            <th style={{"width": "120px"}}>Regions:</th>
                            <td>{offices.join(",")}</td>
                          </tr>
                          <tr>
                            <th>Agencies:</th>
                            <td>{agencies.join(",")}</td>
                          </tr>
                          <tr>
                            <th>File Number:</th>
                            <td>{FileNumber}</td>
                          </tr>
                          <tr>
                            <th>Title:</th>
                            <td>{Title}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    {
                      isLoaded ? (
                        <>
                          <h3>Your result contained {total} records{resultsDescription}.</h3>
                          {
                            total === 0 ? (<h4>Sorry, there are no records matching your search criteria</h4>) : (<div className="lui-divider lui-standard-form">
                              <table className="lui-base-table lui-table-zebra">
                                <thead>
                                  <tr>
                                    <th style={{"width": "50px"}}>
                                      <MultiCheckbox style={{"top": "0rem"}} key="checkedall" name="checkedall" value="checkedall" onChange={this.handleAllChecked} />
                                    </th>
                                    <th style={{"width": "200px"}}>File Number</th>
                                    <th>Title</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {
                                    items.map((item, index) => {
                                      return (
                                        <tr key={"tr-" + item.URI}>
                                          <td className="lui-align-baseline">
                                            <MultiCheckbox style={{"top": "0rem"}} key={item.URI} name={item.URI} value={item.URI} checked={item["isChecked"]} onChange={this.handleChecked} />
                                          </td>
                                          <td className="lui-align-baseline"><LuiButton level="text" onClick={() => this.showDetail(item.URI)}>{item.FileNumber}</LuiButton></td>
                                          <td>
                                            {item.Title + " (Opened: " + item.DateCreated + ", Closed: " + item.DateClosed + ")"}
                                          </td>
                                        </tr>
                                      )
                                    })
                                  }
                                </tbody>
                              </table>
                              {
                                noFilesError && (
                                  <LuiToastMessage onClose={ () => { this.setState({noFilesError: false})} } level="error">
                                    <p>You have not selected any records</p>
                                  </LuiToastMessage>
                                )
                              }
                            </div>
                            )
                          }
                          <p>
                            {
                              total !== 0 ? (<LuiButton onClick={() => this.requestFiles()}>Request Files</LuiButton>) : (<></>)
                            }
                            <LuiButton onClick={() => this.searchAgain()}>Search Again</LuiButton>
                          </p>
                        </>
                      ) : (
                        <div className="g-flex-container lui-margin-bottom-xxl">
                          <LuiLoadingSpinner />
                        </div>
                      )
                    }
                  </>
                )
            }
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(Results);
